import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppLogo } from '../components/AppLogo.js';

export const AuthLayout: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100dvh',
        width: '100%',
        padding: '24px 16px',
        backgroundColor: 'var(--color-bg-primary)',
        paddingTop: 'max(24px, env(safe-area-inset-top))',
        paddingBottom: 'max(24px, env(safe-area-inset-bottom))',
      }}
    >
      <div style={{ marginBottom: '24px' }}>
        <AppLogo size="lg" />
      </div>

      <div
        className="ios-card"
        style={{
          width: '100%',
          maxWidth: '400px',
          padding: '28px 20px',
          boxShadow: 'var(--shadow-lg)',
        }}
      >
        <Outlet />
      </div>

      <footer
        style={{
          marginTop: '24px',
          textAlign: 'center',
          fontSize: '0.75rem',
          color: 'var(--color-text-muted)',
        }}
      >
        PAY888 Protected Authentication — Sandbox Mode
      </footer>
    </div>
  );
};
